import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@/stores";
import { tenantMemberSelects, tenantMemberThunks } from "./store";
import { MemberRead } from "./types";
// components
import { Button, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { CreateModal } from "./CreateModal";

export const TenantManageMembersPage = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantMemberSelects.loading);

  const members = useAppSelector(tenantMemberSelects.members);

  useEffect(() => {
    void dispatch(tenantMemberThunks.list());
  }, [dispatch]);

  const columns: ColumnsType<MemberRead> = [
    {
      width: 150,
      title: t("domains.Member.id"),
      dataIndex: "id",
    },
    {
      width: 180,
      title: t("domains.Member.username"),
      dataIndex: "username",
    },
    {
      width: 180,
      title: t("domains.Member.name"),
      dataIndex: "name",
    },
    {
      title: t("domains.Member.address"),
      dataIndex: "address",
    },
    {
      width: 90,
      align: "right",
      className: "v:top",
      title: t("domains.Member.createdAt"),
      key: "created_at",
      sorter: () => 1,
      render(_, { created_at }) {
        return created_at ? <div>{dayjs.$ldts(created_at)}</div> : null;
      },
    },
    {
      width: 160,
      title: "",
      key: "action",
      render() {
        return (
          <div className="flex gap:8">
            <Button type="primary">{t("systems.Action.edit")}</Button>
            <Button danger type="primary">
              {t("systems.Action.delete")}
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="flex flex:col gap:8">
      <div className="flex jc:end gap:8">
        <CreateModal />
      </div>

      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={members}
        scroll={{ x: "1600px" }}
      ></Table>
    </div>
  );
};
